import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Field, Formik } from "formik";
import {
  Center,
  FlexContainer,
} from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/roadmap/public-roadmap";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import { hideModal } from "../../../../../../store/actions/modal";
import { AcademyDto } from "../../../../../../types/academy.dto";
import { CurrentDto } from "../../../../../../types/current.dto";
import DinamicField from "../../../../../../components/Form/DinamicField";
import { LetterModal } from "./style";
import { CohortDto } from "../../../../../../types/cohort.dto";
import { UnitDto } from "../../../../../../types/unit.dto";
import { StateDto } from "../../../../../../types/states.dto";
import { resetUpdateCDOCs } from "../../../../../../store/actions/cdoc";
import { RoadmapDto } from "../../../../../../types/roadmap.dto";
import {
  newRoadmap,
  updateRoadmap,
} from "../../../../../../store/actions/roadmap";
import { UserDto } from "../../../../../../types/user.dto";
import { setFormData } from "../../../../../../helpers/formData";
import DinamicLinked from "../../../../../../components/Form/DinamicLinked";
import Loader from "../../../../../../components/Loader";

const Component = ({
  academies,
  cohorts,
  current,
  units,
  roadmap,
  updateStates,
  newStates,
  roadmapDataChanged,
  user,
  nodes,
  edges,
  roadmapImage,
}: {
  academies: AcademyDto[];
  roadmapDataChanged: any;
  newStates: StateDto;
  cohorts: CohortDto[];
  current: CurrentDto;
  units: UnitDto[];
  roadmap: RoadmapDto;
  updateStates: StateDto;
  user: UserDto;
  nodes;
  edges;
  roadmapImage;
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const [activeAcademy, setActiveAcademy] = useState<any>();
  const dispatch = useDispatch();
  const onSubmit = ({ values, actions }) => {
    if (!!roadmap) {
      dispatch(
        updateRoadmap({
          _id: roadmap._id,
          body: setFormData(
            {
              name: values.name,
              cohorts: values.cohorts,
              description: values.description,
              units: values.units.map((unit) => unit.value),
              ...(!!roadmapImage && { picture: roadmapImage.file }),
              graph: JSON.stringify({ nodes: nodes, edges: edges }),
              published: true,
              available: values.available,
              allCohorts: values.allCohorts,
              __v: roadmap.__v,
            },
            ["picture"]
          ),
        })
      );
    } else {
      dispatch(
        newRoadmap(
          setFormData(
            {
              name: values.name,
              cohorts: values.cohorts,
              description: values.description,
              graph: JSON.stringify({ nodes: nodes, edges: edges }),
              picture: roadmapImage.file,
              units: values.units.map((unit) => unit.value),
              type: "ROADMAP",
              published: true,
              academy: current.id,
              available: values.available,
              allCohorts: values.allCohorts,
            },
            ["picture"]
          )
        )
      );
    }

    setFormActions(actions);
  };
  useEffect(() => {
    if (updateStates.success) {
      toast.success("👌🏼 Cdoc publicado");

      setTimeout(() => {
        dispatch(resetUpdateCDOCs());
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }

    if (updateStates.error) {
      toast.error(`😱 ${updateStates.error}`);

      setTimeout(() => {
        dispatch(resetUpdateCDOCs());
      }, 1000);
    }
  }, [updateStates]);
  return (
    <Modal name="publish-roadmap-modal" title={`Publicar Roadmap`}>
      {!units ? (
        <Loader color="Primary"></Loader>
      ) : (
        <Formik
          initialValues={{
            ...initialValues({
              ...(!!roadmap && {
                units: roadmap.units.map((unit) => {
                  const unitFounded = units.find(
                    (unitFounded) => unitFounded._id === unit
                  );
                  return {
                    label: unitFounded?.name,
                    value: unitFounded?._id,
                  };
                }),
                cohorts: roadmap.cohorts,
                available: roadmap.available,
                allCohorts: roadmap.allCohorts,
              }),
              description: roadmapDataChanged.description,
              name: roadmapDataChanged.name,
            }),
          }}
          onSubmit={(values, actions) => {
            if (onSubmit) onSubmit({ values, actions });
          }}
          validateOnChange={formSubmmited}
          validateOnMount={true}
          validateOnBlur={false}
          validationSchema={schema}
          enableReinitialize
        >
          {({
            touched,
            errors,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            setFieldValue,
            isSubmitting,
          }) => {
            return (
              <form
                className="theme-form"
                onSubmit={(event) => {
                  setFormSubmmited(true);
                  handleSubmit(event);
                }}
                id="publish-form"
              >
                <Grid.Row style={{ marginBottom: "20px" }}>
                  <Grid.Col>
                    <FlexContainer
                      justify="space-between"
                      style={{ padding: "0px 0px 0px 20px" }}
                    >
                      <FlexContainer
                        direction="column"
                        gap="2px"
                        style={{ maxWidth: "300px" }}
                      >
                        <FlexContainer align="center" gap="1px">
                          <LetterModal lg>Publicación General</LetterModal>
                          <LetterModal lg gray>
                            (Recomendado):
                          </LetterModal>
                        </FlexContainer>
                        <LetterModal gray>
                          El contenido se publicara para todo el publico de
                          Constana Campus, dándole visibilidad a tu Academia y
                          contenidos a nuevos usuarios.
                        </LetterModal>
                      </FlexContainer>
                      <Field
                        style={{
                          width: "20px",
                          height: "20px",
                          boxShadow: "0 0 4px 0 rgba(21, 115, 229, 0.16)",
                        }}
                        type="checkbox"
                        name="available"
                      />
                    </FlexContainer>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row style={{ marginBottom: "20px" }}>
                  <Grid.Col>
                    <FlexContainer
                      justify="space-between"
                      style={{ padding: "0px 0px 0px 20px" }}
                    >
                      <FlexContainer
                        direction="column"
                        gap="2px"
                        style={{ maxWidth: "300px" }}
                      >
                        {" "}
                        <FlexContainer align="center" gap="1px">
                          <LetterModal lg>Compartir entre Cohorts</LetterModal>
                        </FlexContainer>
                        <LetterModal gray>
                          Mostrar a todos los cohorts de la academia
                        </LetterModal>
                      </FlexContainer>
                      <Field
                        style={{
                          width: "20px",
                          height: "20px",
                          boxShadow: "0 0 4px 0 rgba(21, 115, 229, 0.16)",
                        }}
                        type="checkbox"
                        name="allCohorts"
                      />
                    </FlexContainer>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <DinamicField
                      name="cohorts"
                      error={errors["cohorts"]}
                      touched={touched["cohorts"]}
                      value={values["cohorts"]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={{
                        itemOnClick: {
                          functionItem: (value) =>
                            setActiveAcademy((state) =>
                              state === value ? undefined : value
                            ),
                          value: activeAcademy,
                        },
                        onDelete: (item, index) => {
                          setFieldValue(
                            "units",
                            values["units"].filter((val) => val.linked !== item)
                          );
                        },
                        skin: "gray",
                        type: "select",
                        height: "95px",
                        ...(!!academies &&
                          !!cohorts && {
                            data: cohorts
                              ?.filter(
                                (cohort) =>
                                  cohort.active &&
                                  cohort.academy._id === current.id
                              )
                              .map((cohort) => {
                                return {
                                  value: cohort._id,
                                  label: cohort.name,
                                };
                              }),
                          }),

                        loading: !cohorts,
                        inputLabel: "Seleccionar Cohorts (Opcional)",
                        inputPlaceholder: "Selecciona un Cohort",
                      }}
                    />
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <DinamicLinked
                      name="units"
                      error={errors["units"]}
                      touched={touched["units"]}
                      value={values["units"]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={{
                        notLoading: true,
                        skin: "gray",
                        type: "select",
                        height: "95px",
                        ...(!!units &&
                          !!activeAcademy && {
                            data: units
                              .filter(
                                (unit) =>
                                  unit.active &&
                                  unit.cohort.includes(activeAcademy)
                              )
                              .map((cohort) => {
                                return {
                                  linked: activeAcademy,
                                  value: cohort._id,
                                  label: cohort.name,
                                };
                              }),
                          }),
                        externalData: true,
                        loading: !units,
                        inputLabel:
                          "Seleccionar Módulos del Cohort Seleccionado",
                        inputPlaceholder: "Selecciona un Modulo",
                      }}
                    ></DinamicLinked>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <Center gap={"10px"}>
                      <Submit
                        isSubmmiting={
                          !!roadmap ? updateStates.loading : newStates.loading
                        }
                        form="publish-form"
                        color="Primary"
                        style={{ width: "170px" }}
                        options={{
                          type: "filled",
                          skin: "primary",
                          size: "lg",
                          marginBottom: "0px",
                        }}
                      >
                        Confirmar
                      </Submit>
                      <Button
                        onClick={resetForm}
                        type="button"
                        options={{
                          type: "outline",
                          skin: "danger",
                          size: "lg",
                          marginBottom: "0px",
                        }}
                        style={{ marginLeft: "10px", width: "170px" }}
                      >
                        Cancelar
                      </Button>
                    </Center>
                  </Grid.Col>
                </Grid.Row>
              </form>
            );
          }}
        </Formik>
      )}
    </Modal>
  );
};

const states = ({
  academyStore,
  cohortStore,
  currentStore,
  unitStore,
  userStore,
  roadmapStore,
}) => {
  const { data: academies } = academyStore.all;
  const { data: cohorts } = cohortStore.allCohorts;
  const { data: current } = currentStore;
  const { data: units } = unitStore.allUnits;
  const { states: updateStates } = roadmapStore.update;
  const { states: newStates } = roadmapStore.new;
  const { data: user } = userStore;
  return { academies, cohorts, current, units, updateStates, user, newStates };
};

export default connect(states)(Component);
